import React from 'react';
import { Grid, Typography } from '@rentacenter/racstrap';

interface LoadingSpinnerProps {
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
}) => {
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{ padding: '40px 0' }}
    >
      <Grid item>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '16px',
          }}
        >
          <div
            style={{
              width: '40px',
              height: '40px',
              border: '4px solid #f3f3f3',
              borderTop: '4px solid #1976d2',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
            }}
          />
          <Typography variant="body1" style={{ color: '#666' }}>
            {message}
          </Typography>
        </div>
      </Grid>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </Grid>
  );
};

export default LoadingSpinner;
